<template>

        <header>

        </header>
        <main class="container">
            <div >
                <router-view/>
            </div>
        </main>

        <footer>

        </footer>

</template>

<style>
@import '@/assets/styles/style.css';
</style>


<script>
import { store } from '@/store'

export default {
    components: {
    },
    created() {
    },
    data() {
        return {
            store,
        }
    },
    methods: {

    }
}
</script>